// Typed, fail-loud accessor over import.meta.env (init-handoff §4.1).
const API_URL = import.meta.env.VITE_API_URL ?? "";
const WS_URL = import.meta.env.VITE_WS_URL ?? "";

export const env = {
  // Empty => same-origin (dev proxy). Trailing slash stripped.
  apiBase: API_URL.replace(/\/+$/, ""),
  // Derive ws base from apiBase or current origin when not set.
  wsBase: (WS_URL || deriveWs(API_URL)).replace(/\/+$/, ""),
  siteName: import.meta.env.VITE_SITE_NAME ?? "maitv",
  passkeyRpId: import.meta.env.VITE_PASSKEY_RP_ID ?? "localhost",
};

function deriveWs(apiUrl: string): string {
  const base = apiUrl || (typeof location !== "undefined" ? location.origin : "");
  return base.replace(/^http/, "ws") + "/ws";
}
